__turbopack_context__.v({
  "cardHeader": "SequenceSelection-module__QPbJpq__cardHeader",
  "cardHeaderCollapsible": "SequenceSelection-module__QPbJpq__cardHeaderCollapsible",
  "descriptionClamped": "SequenceSelection-module__QPbJpq__descriptionClamped",
  "tag": "SequenceSelection-module__QPbJpq__tag",
  "tagList": "SequenceSelection-module__QPbJpq__tagList",
  "tagListExpanded": "SequenceSelection-module__QPbJpq__tagListExpanded",
  "topicsContent": "SequenceSelection-module__QPbJpq__topicsContent",
  "topicsHeader": "SequenceSelection-module__QPbJpq__topicsHeader",
  "topicsSection": "SequenceSelection-module__QPbJpq__topicsSection",
  "topicsSectionCollapsible": "SequenceSelection-module__QPbJpq__topicsSectionCollapsible",
  "topicsToggle": "SequenceSelection-module__QPbJpq__topicsToggle",
});
